module.exports = __webpack_public_path__ + "static/nitish-1776776cffe51e0f70c1327a8d4c435e.png";